import {BrowserRouter as Router} from 'react-router-dom'
import PropTypes from 'prop-types'

import DriveContainer from './components/drive/DriveContainer'
import RouteWithSubRoutes from './components/RouteWithSubRoutes'

const App = ({routes = []}) => {
  const appRoutes = [
    {
      path: '/',
      children: [
        {
          index: true,
          element: <DriveContainer />
        },
        ...routes
      ]
    }
  ]

  return (
    <Router>
      <RouteWithSubRoutes routerConfig={appRoutes} />
    </Router>
  )
}

App.propTypes = {
  routes: PropTypes.array.isRequired
}

export default App
